import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/locale/nl';
import 'vue2-datepicker/locale/fr';
import 'vue2-datepicker/locale/es';
@Component({
  name: 'bpc-time',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'date-picker': DatePicker,
  },
})
export default class Time extends mixins(AbstractField) {
  @Prop(String) readonly value: string;

  get model(): string {
    return this.value;
  }
  set model(val: string) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }
  get hours(): number[] {
    const start_hour =
      this.$store.getters['centerSettings/centerSettings']?.default_start_hour?.slice(0, 2) || '7';
    const end_hour =
      this.$store.getters['centerSettings/centerSettings']?.default_end_hour?.slice(0, 2) || '22';
    return Array.from({ length: parseInt(end_hour) - parseInt(start_hour) + 1 }).map(
      (_, i) => i + parseInt(start_hour),
    );
  }
}
